import './about.scss'
import {Carousel} from 'antd';
import companyUtil from "../../utils/companyUtil";
import {useState, useEffect} from 'react'

var React = require("react")


//关于我们
const About: React.FunctionComponent = () => {
    //左半边的背景图片、不用设为空就行 这样设置为空leftBack = useState("");
    const [leftBack] = useState<string>(require('./../assets//background/about_us_bg.png').default);
    const [tabList] = useState<Array<{ name: string, descText: string, imgSrc: string }>>([
        {
            name: "公司背景",
            descText: companyUtil.name + "是一家国内领先的移动互联网产品研发公司，自成立以来一直专注于移动互联网的创新型技术的科研与突破。目前已在国内垂直行业领域取得了领先水平。",
            imgSrc: require('./../assets/background/company_background_pic.png').default
        },
        {
            name: "企业文化",
            descText: "公司内聚集了一群心怀梦想、团结协作、充满活力的年轻人。学习创新并勇于尝试是一直以来支撑我们这个团队进步的动力源泉。每个人都坚信我们现在正在做的是一件有意义的事情，终将实现共同的理想-我们不是大厂，我们正在创造大厂！",
            imgSrc: require('./../assets/background/corporate_culture_pic.png').default
        },
    ]);
    //Carousel的ref对象
    const varousel = React.useRef();
    const varousel2 = React.useRef();
    //判断该组件是否hover
    const [isLeftHover, setIsLeftHover] = useState<boolean>(true);
    const [isRightHover, setIsRightHover] = useState<boolean>(true);
    //当前index
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {

    })


    /**
     * 切换到下一张
     */
    const next = (val: any) => {
        let index = currentIndex + 1;
        if (index >= tabList.length) {
            index = 0
        }
        setCurrentIndex(index)
        varousel.current.next();
        varousel2.current.next();
    }

    /**
     * 切换到上一张
     */
    const prev = () => {
        let index = currentIndex - 1;
        if (index < 0) {
            index = tabList.length - 1;
        }
        setCurrentIndex(index)
        varousel.current.prev();
        varousel2.current.prev();
    }

    /**
     * 跳转页面
     */
    const goTo = (index: any) => {
        setCurrentIndex(index)
        varousel.current.goTo(index);
        varousel2.current.goTo(index);
    }


    return (
        <div className="aboutBigBox" style={{"height": window.innerHeight + 'px'}}>
            {!!leftBack && (
                <div className="letBackBox">
                    <img className="letBack" src={leftBack} alt=""/>
                </div>
            )}
            <div className="aboutPage">
                <div className="leftBox">
                    <div className="titleBox">
                        {
                            tabList.map((item, index) => {
                                return (
                                    <div onClick={() => goTo(index)} className={currentIndex == index ? "titleItem" : "titleItemNo"} key={index}>
                                        <p>{item.name}</p>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className="descBox">
                        <Carousel
                            infinite={true}
                            draggable={false}
                            vertical={true}
                            verticalSwiping={true}
                            ref={varousel}
                            effect="fade"
                            dots={false}

                        >
                            {
                                tabList.map((item, index) => {
                                    return (
                                        <div className="descItem" key={index}>
                                            <p>{item.descText}</p>
                                        </div>
                                    )
                                })
                            }
                        </Carousel>
                    </div>
                    <div className="dotsBoxBtn"
                    >
                        <div className="leftIconBox"
                             onMouseEnter={() => setIsLeftHover(false)}
                             onMouseLeave={() => setIsLeftHover(true)}
                             onClick={() => prev()}
                        >
                            <img
                                className="IconImg"
                                src={
                                    !!isLeftHover ?
                                        require('./../assets/icon/switch_left_uncheck.png').default
                                        :
                                        require('./../assets/icon/switch_left_check.png').default
                                } alt=""/>
                        </div>
                        <div className="leftIconBox"
                             onMouseEnter={() => setIsRightHover(false)}
                             onMouseLeave={() => setIsRightHover(true)}
                             onClick={(val) => next(val)}
                        >
                            <img
                                className="IconImg"
                                src={
                                    !!isRightHover ?
                                        require('./../assets/icon/switch_right_uncheck.png').default
                                        :
                                        require('./../assets/icon/switch_right_check.png').default
                                } alt=""/>
                        </div>
                    </div>
                </div>
                <div className="backImgBox">
                    <Carousel
                        infinite={true}
                        draggable={false}
                        vertical={true}
                        verticalSwiping={true}
                        ref={varousel2}
                        effect="fade"
                        dots={false}
                    >
                        {
                            tabList.map((item, index) => {
                                return (
                                    <div key={index}>
                                        <img className="backImg" src={item.imgSrc} alt=""/>
                                    </div>
                                )
                            })
                        }
                    </Carousel>
                </div>
            </div>
        </div>
    )

}

export default About
